<!---->
<template>
  <el-dropdown v-bind="$attrs"> <slot /> </el-dropdown>
</template>

<script>
export default {
  name: 'RtDropdown',
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// rtDropdown.vue?dca23216